import { TriangleAlert } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ApiError } from "@/lib/api";
import { cn } from "@/lib/utils";

type ErrorStateProps = { error?: unknown; message?: string; onRetry?: () => void; className?: string };

export function errorMessage(error: unknown, fallback = "Algo salió mal"): string {
  if (error instanceof ApiError) return error.status ? `${error.message} (HTTP ${error.status})` : error.message;
  if (error instanceof Error) return error.message || fallback;
  return fallback;
}

export function ErrorState({ error, message, onRetry, className }: ErrorStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-xl border border-dashed border-[#ffb4b4] px-6 py-10 text-center dark:border-[#5a2a2a]",
        className,
      )}
      role="alert"
    >
      <TriangleAlert className="mb-3 h-6 w-6 text-[#ff3434]" />
      <p className="text-sm font-medium">{message ?? errorMessage(error)}</p>
      {onRetry ? (
        <Button className="mt-4 border-[#dfe3eb] dark:border-[#3f4548]" onClick={onRetry} size="sm" variant="outline">
          Reintentar
        </Button>
      ) : null}
    </div>
  );
}
